export const nLoaderSpinner = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center'
};

export const nLoaderOverlay = {
  position: 'fixed',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  zIndex: 9999,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
};

export const nLoaderBackdrop = {
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: 'rgba(0, 0, 0, 0.64)',
  backdropFilter: 'blur(35px)',
  WebkitBackdropFilter: 'blur(35px)'
};

export const nLoaderContent = {
  position: 'relative',
  zIndex: 1,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 2
};

export const spinnerSvg = {
  width: '48px',
  height: '48px'
};

export const rotating = {
  animation: 'spin 1s cubic-bezier(0.85, 0.46, 0.56, 0.71) infinite',
  transformOrigin: 'center',
  '@keyframes spin': {
    '0%': {
      transform: 'rotate(-90deg)'
    },
    '100%': {
      transform: 'rotate(270deg)'
    }
  }
};

export const nLoaderSpinnerDisabled = {};
